import { ActionsUnion, createAction } from '../helpers';
import { IGetPaymentHistoriesSuccessPayload } from './types';

export enum EPaymentHistoriesActionType {
  GET = 'PAYMENT_HISTORIES/GET',
  GET_SUCCESS = 'PAYMENT_HISTORIES/GET_SUCCESS',
}

export const paymentHistoriesAction = {
  getPaymentHistories: () => createAction(EPaymentHistoriesActionType.GET),
  getPaymentHistoriesSuccess: (payload: IGetPaymentHistoriesSuccessPayload) =>
    createAction(EPaymentHistoriesActionType.GET_SUCCESS, payload),
};

export type TPaymentHistoriesAction = ActionsUnion<
  typeof paymentHistoriesAction
>;
